import * as awsui from "@cloudscape-design/design-tokens";
import { 
  Navbar, 
  Dropdown, 
  Button, 
  Link, 
  Text, 
  User,
} from "@nextui-org/react"; // https://nextui.org/docs/components/navbar
import { useAuthenticator } from '@aws-amplify/ui-react';
import { GlobalContext } from "../../context";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useRef } from "react";
import { navigateFn } from "../../routingHelper";
import { useMediaQuery } from 'react-responsive';
import { Collection } from "typescript";


export default function AuthContent() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const ref = useRef(null);
  const { 
    authInitialState, setAuthInitialState,
    userAttributes, setUserAttributes,
  } = useContext(GlobalContext);
  const { user, signOut, toSignIn, toSignUp, toResetPassword } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); // https://ui.docs.amplify.aws/react/connected-components/authenticator/advanced
  const { authStatus } = useAuthenticator(context => [context.authStatus]); // https://ui.docs.amplify.aws/react/connected-components/authenticator/advanced

  const collapseNavBar = useMediaQuery({query: "only screen and (min-width : 900px)"});

  if (!collapseNavBar) return <></>


  const getUserMenuItems = () => {
    const userMenuItems = []
    userMenuItems.push({ label: "FRG Account", key: "account", withDivider: false, color: "primary" }) 

    if (userAttributes.groups){
      if (
        userAttributes.groups.includes("MotorsportAU") || 
        userAttributes.groups.includes("MotorsportUK") || 
        userAttributes.groups.includes("MotorsportNZ")
      ) userMenuItems.push(
          { label: "Motorsport Admin", key: "motorsportAdmin", withDivider: false, color: "primary" }
        )
      if (userAttributes.groups.includes("LeagueAdmin")) userMenuItems.push(
        { label: "Admin", key: "leagueAdmin", withDivider: false, color: "primary" }
      )
    }
    userMenuItems.push({ label: "Sign Out", key: "signout", withDivider: true, color: "error" })

    return userMenuItems
  }



  if (route === "authenticated") {
    const userAttributes = user.getSignInUserSession()!.getIdToken().payload
    userAttributes.username = user.getSignInUserSession()!.getIdToken().payload["cognito:username"]
    userAttributes.groups = user.getSignInUserSession()!.getAccessToken().payload["cognito:groups"]

    return (
      <>
        <Dropdown placement="bottom-right">
          <Navbar.Item>
            <Dropdown.Trigger>
              <User
                bordered
                as="button"
                size="lg"
                color="primary"
                name={userAttributes.given_name}
                description={userAttributes.email}
                src={userAttributes.picture}
              />
            </Dropdown.Trigger>
          </Navbar.Item>
          <Dropdown.Menu
            data-nav-user-menu
            aria-label="User menu actions"
            color="primary"
            key={"nav-user-menu"}
            onAction={(actionKey) => {
              switch (actionKey) {
                case "signout":
                  signOut()
                  navigate("/");
                  break;
                case "signin":
                  navigate("/signin")
                  break;
                case "account":
                  navigate("/account")
                  break;
                case "leagueAdmin":
                  navigate("/league-admin")
                  break;
                case "teamAdmin":
                  navigate("/team-admin")
                  break;
                case "motorsportAdmin":
                  navigate("/motorsport-admin")
                  break;
              }
            }}
            css={{
              background: awsui.colorBackgroundDropdownItemDefault,
            }}
          >
            { getUserMenuItems().map( ( item ) => {
              return (
                <Dropdown.Item key={item.key} withDivider={item.withDivider} color={item.color as any}>
                  {item.label}
                </Dropdown.Item>
              )
            })}
          </Dropdown.Menu>
        </Dropdown>
      </>
    )
  }

  return (
    <>
      <Navbar.Link 
        css={{ color: awsui.colorTextBodyDefault }} 
        onClick={ (event) => {
          event.preventDefault();
          setAuthInitialState("signIn");
          navigate("signin");
          toSignIn();
        }}
      >
        Sign In
      </Navbar.Link>
      <Navbar.Item>
        <Button 
          auto 
          as={Link} 
          onClick={ (event) => {
            setAuthInitialState("signUp");
            navigate("signin");
            toSignUp();
          }}
          color="primary" 
        >
          Sign Up
        </Button>
      </Navbar.Item>
    </>
  )
}
